import { AniParmType } from "./AnimatorControllerParse";

export class Animation2DParm {
    name: string;
    type: AniParmType;
    value: boolean | number;
}